import { render, staticRenderFns } from "./ServidorPublico.vue?vue&type=template&id=3fca78a0"
import script from "./ServidorPublico.vue?vue&type=script&lang=js"
export * from "./ServidorPublico.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublico.vue?vue&type=style&index=0&id=3fca78a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports